import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import PageHeader from "@/components/PageHeader";
import StatusBadge from "@/components/StatusBadge";
import { fmtCurrency, fmtDate } from "@/lib/format";

export default function Units() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/customer/units").then((r) => setItems(r.data)); }, []);

  return (
    <div className="space-y-8" data-testid="customer-units-page">
      <PageHeader eyebrow="Portfolio" title="My units" description="All units you own with this developer." />

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {items.map((o) => (
          <div key={o.id} className="grid-surface overflow-hidden" data-testid={`my-unit-${o.unit_id}`}>
            <div className="relative h-40 bg-stone-200">
              {o.project?.cover_url && <img src={o.project.cover_url} alt="" className="w-full h-full object-cover" />}
              <div className="absolute top-3 left-3"><StatusBadge value={o.unit?.status} /></div>
            </div>
            <div className="p-5">
              <div className="overline text-stone-500">{o.project?.name}</div>
              <h3 className="font-display text-xl font-bold mt-1">Unit {o.unit?.unit_no}</h3>
              <div className="grid grid-cols-3 mt-4 border-t border-stone-200 pt-3 gap-2 font-mono text-xs">
                <div><div className="text-stone-400">TOWER</div><div className="text-stone-950 font-bold">{o.tower?.name}</div></div>
                <div><div className="text-stone-400">TYPE</div><div className="text-stone-950 font-bold">{o.unit?.unit_type || "—"}</div></div>
                <div><div className="text-stone-400">SIZE</div><div className="text-stone-950 font-bold">{o.unit?.size_sqft || "—"} sqft</div></div>
                <div><div className="text-stone-400">PURCHASED</div><div className="text-stone-950 font-bold">{fmtDate(o.purchase_date)}</div></div>
                <div className="col-span-2"><div className="text-stone-400">TOTAL PRICE</div><div className="text-stone-950 font-bold">{fmtCurrency(o.total_price)}</div></div>
              </div>
            </div>
          </div>
        ))}
        {items.length === 0 && (
          <div className="grid-surface border-dashed p-10 text-center overline text-stone-400 col-span-full">
            No units mapped to your account yet
          </div>
        )}
      </div>
    </div>
  );
}
